export const RouteNames = {
  HOME: "/",
  ABOUT: "/about",
};
